import React, { useEffect, useState } from 'react';
import { useMatchDetails, useMatchConfig } from '../hooks/matchdetails';
import MatchHeaderOngoingFinished from '../components/MatchDetails/MatchHeaderOngoingFinished';
import MatchHeaderUpcoming from '../components/MatchDetails/MatchHeaderUpcoming';
import MatchStats from '../components/MatchDetails/MatchStats';
import Formation from '../components/MatchDetails/Formation';
import Timeline from '../components/MatchDetails/Timeline';
import TeamForm from '../components/MatchDetails/TeamForm';
import TeamNews from '../components/MatchDetails/TeamNews';
import TopPlayers from '../components/MatchDetails/TopPlayers';
import MatchUpStandings from '../components/MatchDetails/MatchUpStandings';
import { LEAGUES } from '../constants/leagues';
import FutsalFormation from '../components/MatchDetails/FutsalFormation';
import HighlightsReel from '../components/FotbollPlay/HighlightsReel';
import { MATCH_STATUS } from '../constants/match';
import Tabs from '../components/MatchDetails/Tabs';
import MatchPlayerStats from '../components/MatchDetails/MatchPlayerStats';
import Loader from '../components/Loader';
import MatchStatsFutsal from '../components/MatchDetails/MatchStatsFutsal';

function MatchDetails() {
  const { id, season } = window.pageData.data;
  const [match, loading] = useMatchDetails(id, season);

  const [currentTab, setCurrentTab] = useState(0);
  const [matchConfigOriginal] = useMatchConfig(
    match?.id,
    match?.configSeasonStartYear
  );

  const matchConfig = {
    ...matchConfigOriginal,
    // /matcher/2024/4456713/aik-mot-ik-sirius
    // hidePlayerStats: {
    //   908521: {
    //     // Bersant Celina
    //     maxSpeed: false,
    //     distance: true,
    //   },
    //   1316974: {
    //     // Rui Modesto
    //     maxSpeed: true,
    //     distance: false,
    //   },
    //   1384657: {
    //     // Bersant Celina
    //     maxSpeed: true,
    //     distance: true,
    //   },
    // },
  };

  const switchContent = (newTab) => {
    setCurrentTab(newTab);
  };

  useEffect(() => {
    if (match?.status === MATCH_STATUS.ONGOING) {
      switchContent(1);
    }
    if (match?.status === MATCH_STATUS.FINISHED) {
      switchContent(3);
    }
  }, [match]);

  if (loading) return <Loader />;

  return (
    <>
      <div className="site-container site-container--hug-on-mobile">
        <section className="hero-image">
          <a className="hero-image__back" href="/matcher">
            <img
              src="/wp-content/themes/sef-leagues/images/arrow-back.svg"
              alt="Back"
            />
          </a>
          {match.status === MATCH_STATUS.UPCOMING ? (
            <MatchHeaderUpcoming match={match} />
          ) : (
            <MatchHeaderOngoingFinished
              match={match}
              matchConfig={matchConfig}
            />
          )}
        </section>
      </div>
      {match?.configLeagueName !== LEAGUES.FUTSAL && (
        <section className="row col-12 text-center mb-4 d-none d-lg-block">
          <a
            href="https://www.max.com/se/sv"
            target="_blank"
            rel="nofollow noreferrer"
          >
            <img
              height="24"
              src="/wp-content/themes/sef-leagues/images/max-logo-white.png"
              alt=""
            />
          </a>
        </section>
      )}
      <Tabs switchContent={switchContent} currentTab={currentTab} />
      <section className="tabs-content site-container full-width">
        {currentTab === 0 && (
          <>
            <MatchUpStandings match={match} />
            <TeamNews
              abbrv={match?.homeTeamAbbrv}
              teamName={match?.homeTeamName}
            />
            <TeamNews
              abbrv={match?.visitingTeamAbbrv}
              teamName={match?.visitingTeamName}
            />
            {match?.configLeagueName !== LEAGUES.FUTSAL && (
              <>
                <TopPlayers match={match} />
                <TeamForm match={match} />
              </>
            )}
          </>
        )}

        {currentTab === 1 && <Timeline match={match} />}

        {currentTab === 2 && (
          <div className="row tabs-content">
            <div className="col-12 tabs-column mt-0">
              {match?.configLeagueName === LEAGUES.FUTSAL ? (
                <FutsalFormation match={match} />
              ) : (
                <>
                  <Formation match={match} homeTeam />
                  <Formation match={match} />
                </>
              )}
            </div>
          </div>
        )}

        {currentTab === 3 && (
          <div className="row tabs-content">
            <div className="col-12 tabs-column mt-0">
              {match?.configLeagueName === LEAGUES.FUTSAL ? (
                <MatchStatsFutsal match={match} />
              ) : (
                <>
                  <MatchStats match={match} matchConfig={matchConfig} />
                  {matchConfig?.hideStats?.distance === false && (
                    <MatchPlayerStats match={match} matchConfig={matchConfig} />
                  )}
                </>
              )}
            </div>
          </div>
        )}

        {match?.configLeagueName !== LEAGUES.FUTSAL && (
          <div className="row tabs-content">
            <div className="col-12 tabs-column">
              {match?.playlists?.highlights && (
                <div className="video__container video__container--two-col">
                  <HighlightsReel video={match?.playlists?.highlights} />
                </div>
              )}
            </div>
          </div>
        )}
      </section>
    </>
  );
}

export default MatchDetails;
